export const langchainConfig = {
  // Configurações do OpenAI
  openai: {
    apiKey: process.env.REACT_APP_OPENAI_API_KEY || '',
    modelName: process.env.REACT_APP_OPENAI_MODEL || 'gpt-4.1-mini',
    temperature: parseFloat(process.env.REACT_APP_OPENAI_TEMPERATURE || '0.7'),
    maxTokens: parseInt(process.env.REACT_APP_OPENAI_MAX_TOKENS || '500')
  },

  // Configurações dos prompts
  prompts: {
    intentAnalysis: {
      temperature: 0.1, // Baixa temperatura para análise de intenção
      maxTokens: 150
    },
    contextualResponse: {
      temperature: 0.7, // Temperatura média para respostas criativas
      maxTokens: 500
    }
  },

  // Configurações de fallback
  fallback: {
    enabled: true,
    confidenceThreshold: 0.7
  },

  // Configurações de contexto
  context: {
    maxHistoryMessages: 5,
    maxRecentDocuments: 3
  }
};

// Validação da configuração
export const validateLangchainConfig = () => {
  if (!langchainConfig.openai.apiKey) {
    console.warn('⚠️ LLM_API_KEY não configurada. O LangChain pode não funcionar corretamente.');
    return false;
  }
  return true;
}; 